export default {
  pickingListItems: [],
  pickingListItem: undefined,
};
